import CacheMachine from '@/common/utils/CacheMachine'

let shopDetailGalleryList = {
  title: '',
  pics: []
}

let shopBaseDetail = new CacheMachine({})
let currentShopBaseDetail = {}

let shopDetail = new CacheMachine({})
let currentShopDetail = {}

let bizoppDetail = new CacheMachine({})
let currentBizoppDetail = {}
let currentBizoppBillAccount = {}

let allConfig = new CacheMachine({})
let currentAllConfig = {}

let contractorDetail = new CacheMachine({})
let currentContractorDetail = {}

// 信息收集时获取到的合同信息
let shopCollectDetail = new CacheMachine({})
let currentShopCollectDetail = {}
const saleData = {}

let showDatePick = false
let showPicker = false
let backoutApply = false

export default {
  shopDetailGalleryList,
  currentShopBaseDetail,
  shopBaseDetail,
  shopDetail,
  currentShopDetail,
  currentBizoppBillAccount,
  contractorDetail,
  currentContractorDetail,
  shopCollectDetail,
  currentShopCollectDetail,
  bizoppDetail,
  currentBizoppDetail,
  showDatePick,
  showPicker,
  backoutApply,
  allConfig,
  currentAllConfig,
  saleData
}
